module.exports = __webpack_public_path__ + "d81115b78863de35327eba65696a2135.png";